<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

<div class="container-fluid">
  <div class="top-header">
    <div>
      <img src="../../../../assets/img/backMenu.svg" alt="" (click)="backClicked()">
    </div>
    <div class="allergy-rating-title">Allergy Ratings</div>
  </div>
</div>

<div class="container">
  <div class="food-dish-name">
    {{allergyRatingDishName}}
  </div>
  <div class="underline">
    &nbsp;
  </div>

  <div *ngFor="let item of allergyRatingsArray">
    <!-- <img src="{{item.profile_img}}" alt="">  -->
    <div class="first-name pad-10" *ngIf="item.first_name"> <span class="">{{item.first_name}}</span> </div>
    <!-- <div *ngIf="item.review_code" style="margin-top: 10px;"
      [ngClass]="item.review_code > 2 ? 'five-star-rating' : 'uncheckedClass'">{{item.review_code}} <span><img
          src="../../../../assets/img/star1.svg" alt="" class="star-img"></span></div> -->
    <div class="review-message pad-10" *ngIf="item.da_review_text">"{{item.da_review_text}}"</div>
    <div class="underlines">&nbsp;</div>
  </div>
</div>